import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { MenuComponent } from './Menu';
import { PresentationComponent } from './Presentation';
import { SetCssComponent } from './SetCss';

@NgModule({
  declarations: [
    MenuComponent,
    PresentationComponent,
    SetCssComponent,
  ],
  exports: [
    MenuComponent,
    PresentationComponent,
    SetCssComponent,
  ],
  imports: [
    BrowserModule
  ]
})
export class ComponentsModule { }
